import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router';
import { ensureKnown, updateArrangement } from '../store/knownArrangementsSlice';
import TextareaAutosize from 'react-textarea-autosize';
import { DataContainer } from '../components/DataContainer';
import DriverSelect from '../components/DriverSelect';
import TimeInput from '../components/TimeInput';
import { toast } from 'react-toastify';
import EditException from './arrangement/EditException';
import EditReoccurring from './arrangement/EditReoccurring';
import { timestampToDate } from '../util';




function Arrangement(props) {
    const dispatch = useDispatch();
    const location = useLocation();

    const id = useParams()["id"].toUpperCase();
    const date = new URLSearchParams(location.search).get('date');

    console.log("db20: date:", date);


    // ##### Form state #####

    const [ creatingException, setCreatingException ] = useState(!!date);

    const _data = useSelector((state) => state.knownArrangements);
    const data = _data.arrangements[id];

    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);





    
    if(!data) return null;

    return (
        <div className="column p32 screen center-cross">
            <div className="column g32" style={{ width: '100%', maxWidth: 800 }}>
                <div className="column g16">
                    <div className="column w100">
                        <b>Regulaarvedu</b>
                        <h1>{data["arrangement_name"]}</h1>
                    </div>
                    <select name="editing" id="editing" value={""+(+creatingException)} onChange={(e) => setCreatingException(!!(+e.target.value))}>
                        <option value="0">Muuda kogu regulaarvedu</option>
                        <option value="1">Muuda sellel kuupäeval</option>
                    </select>
                </div>

                {creatingException ? (
                    date ? (
                        <EditException id={id} date={date} />
                    ) : (
                        <div className="column">
                            <h2>Erandi loomine</h2>
                            <p>Regulaarveo erandi loomiseks minge lehele "Graafikud" ning seejärel vajutage "Ava" soovitud päeva peal</p>
                        </div>
                    )
                ) : (
                    <EditReoccurring id={id} />
                )}
            </div>
        </div>
    );
};

export default Arrangement;